import { ColorScheme, MastheadVariants, Vertical, VerticalConfig, VerticalConfigs } from 'utils/vertical';
import { SUPPORTED_MESSAGING_LOCALES } from 'providers/messaging/constants';
import {
  ARTISTS_SMARTLING_LOCALES,
  CONSUMER_SMARTLING_LOCALES,
  PODCASTERS_SMARTLING_LOCALES,
  FINDAWAY_SMARTLING_LOCALES,
} from 'utils/i18n/localeConfig';

// These configs might be available in frontend, so don't add anything sensitive like secrets etc
export const verticalConfigs: VerticalConfigs = {
  [Vertical.ARTISTS]: {
    verticalName: Vertical.ARTISTS,
    pathParam: 'artists',
    cms: {
      dataset: process.env.NEXT_PUBLIC_VERTICAL_ARTIST_DATASET ?? 'artists_production',
      projectId: 'tsbk0zvv',
      apiVersion: '2021-10-21',
    },
    features: {
      configureMasthead: {
        header: MastheadVariants.S4A,
        footer: MastheadVariants.S4A,
      },
      configurePillowTalk: {
        lineOfBusiness: 'S4A',
        redirectUri: 'https://support.spotify.com/artists/contact-spotify-anonymous/',
        showLoginDialog: true,
      },
    },
    locales: {
      messagingLocales: SUPPORTED_MESSAGING_LOCALES[Vertical.ARTISTS],
      smartling: ARTISTS_SMARTLING_LOCALES,
    },
    theme: 'encore-creator-light-theme',
    colorScheme: ColorScheme.LIGHT,
    rolloutConfig: null,
  },
  [Vertical.CONSUMER]: {
    verticalName: Vertical.CONSUMER,
    pathParam: '',
    cms: {
      dataset: process.env.NEXT_PUBLIC_VERTICAL_CONSUMER_DATASET ?? 'production',
      projectId: 'tsbk0zvv',
      apiVersion: '2021-10-21',
    },
    features: {
      communityLink: 'https://community.spotify.com/t5/Spotify-Answers/tkb-p/Spotify-Answers',
      showHeaderGradient: true,
      supportEmail: 'support@spotify.com',
      emailMessagingFallback: true,
    },
    locales: {
      messagingLocales: SUPPORTED_MESSAGING_LOCALES[Vertical.CONSUMER],
      smartling: CONSUMER_SMARTLING_LOCALES,
    },
    theme: 'encore-dark-theme',
    colorScheme: ColorScheme.DARK,
    rolloutConfig: null,
  },
  [Vertical.PODCASTERS]: {
    verticalName: Vertical.PODCASTERS,
    pathParam: 'podcasters',
    cms: {
      dataset: process.env.NEXT_PUBLIC_VERTICAL_PODCASTERS_DATASET ?? 'podcasters_production',
      projectId: 'tsbk0zvv',
      apiVersion: '2021-10-21',
    },
    features: {
      configureMasthead: {
        footer: MastheadVariants.TURNKEY,
        header: MastheadVariants.TURNKEY,
        colorSet: 'encore-inverted-dark-set',
      },
      configurePillowTalk: {
        lineOfBusiness: 'S4P',
        redirectUri: 'https://support.spotify.com/podcasters/contact-spotify-anonymous/',
        showLoginDialog: false,
      },
      disableAuthenticatedFeatures: true,
    },
    locales: {
      messagingLocales: SUPPORTED_MESSAGING_LOCALES[Vertical.PODCASTERS],
      smartling: PODCASTERS_SMARTLING_LOCALES,
    },
    theme: 'encore-s4p-light-theme',
    colorScheme: ColorScheme.LIGHT,
    rolloutConfig: null,
  },
  [Vertical.FINDAWAY]: {
    verticalName: Vertical.FINDAWAY,
    pathParam: 'findawayvoices',
    cms: {
      dataset: process.env.NEXT_PUBLIC_VERTICAL_FINDAWAY_DATASET ?? 'findawayvoices_production',
      projectId: 'tsbk0zvv',
      apiVersion: '2021-10-21',
    },
    features: {
      configureMasthead: {
        footer: MastheadVariants.TURNKEY,
        header: MastheadVariants.TURNKEY,
        colorSet: 'encore-inverted-dark-set',
      },
      supportEmail: 'support@findawayvoices.com',
      onlyEmailSupport: true,
      disableAuthenticatedFeatures: true,
    },
    locales: {
      messagingLocales: SUPPORTED_MESSAGING_LOCALES[Vertical.FINDAWAY],
      smartling: FINDAWAY_SMARTLING_LOCALES,
    },
    theme: 'encore-light-theme',
    colorScheme: ColorScheme.LIGHT,
    rolloutConfig: null,
  },
} as const;

export const getVerticalConfigs = (): VerticalConfigs => verticalConfigs;

export const getVerticalConfig = (vertical: Vertical): VerticalConfig => {
  return verticalConfigs[vertical];
};
